module.exports = "https://assets.niwcorp.com/_next/static/images/light-bulb-056fb478b87b3701e5f89e564560ef53.svg";